export default __webpack_public_path__ + "static/media/github.1c95b85d.png";